import React from "react";
import { Input } from "@/components/ui/input";
import { evalFormula } from "@/lib/fabricData";

// A text input that accepts Excel-style arithmetic (+ - * / parentheses,
// decimals). On blur or Enter it evaluates the expression and writes the
// computed number back into the field (so "100+50" becomes "150"). Invalid
// expressions are left untouched. `onValueChange` receives the raw string while
// typing and the computed string on commit; `onCommit` (optional) receives the
// evaluated number (or null if invalid) so callers can persist it.
export function FormulaInput({ value, onValueChange, onCommit, ...props }) {
  const commit = () => {
    const v = evalFormula(value);
    if (v !== null) onValueChange(String(v));
    if (onCommit) onCommit(v, value);
  };
  return (
    <Input
      type="text"
      inputMode="decimal"
      value={value ?? ""}
      onChange={(e) => onValueChange(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          e.currentTarget.blur();
        }
      }}
      {...props}
    />
  );
}
